'use client';

import { c as _c } from "react/compiler-runtime";
import { AccommodationSearchDocument } from '@data-access/lib/gql/accommodations/documents';
import { useGraphQL } from '@data-access/lib/graphql-query';
import { useUrlState } from '@feat/feat-url-state/use-url-state';
import { GERMAN_LOCALE } from '@utils/utils-format';
import { ACCOMMODATION_DETAIL_STALE_TIME, getAccommodationSearchVariables, selectAccommodationSearchResult } from '../_lib/accommodation-detail-query';
export function useAppAccommodationSearch(id) {
  const $ = _c(4);
  const {
    urlState
  } = useUrlState();
  let t0;
  if ($[0] !== id || $[1] !== urlState) {
    t0 = getAccommodationSearchVariables({
      accommodationId: id,
      locale: GERMAN_LOCALE,
      urlState
    });
    $[0] = id;
    $[1] = urlState;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      select: selectAccommodationSearchResult,
      staleTime: ACCOMMODATION_DETAIL_STALE_TIME
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useGraphQL(AccommodationSearchDocument, t0, t1);
}